import type { Role } from "../../types/user";
import styles from "./TeamMemberList.module.css";

interface TeamMember {
  userId: string;
  email: string;
  emailVerified: boolean;
  addedAt: string;
}

interface TeamMemberListProps {
  members: TeamMember[];
  currentUserRole: Role;
  onRemoveMember?: (userId: string, email: string) => void;
  removingMemberId?: string | null;
}

export function TeamMemberList({
  members,
  currentUserRole,
  onRemoveMember,
  removingMemberId,
}: TeamMemberListProps) {
  const canManageMembers = currentUserRole === "owner" || currentUserRole === "admin";

  if (members.length === 0) {
    return <div className={styles.emptyState}>No members in this team yet.</div>;
  }

  return (
    <div>
      <table className={styles.table}>
        <thead className={styles.thead}>
          <tr>
            <th className={styles.th}>Email</th>
            <th className={styles.th}>Status</th>
            <th className={styles.th}>Joined</th>
            {canManageMembers && <th className={styles.th}>Actions</th>}
          </tr>
        </thead>
        <tbody className={styles.tbody}>
          {members.map((member) => (
            <tr key={member.userId} className={styles.tr}>
              <td className={`${styles.td} ${styles.email}`}>{member.email}</td>
              <td className={styles.td}>
                <span
                  className={`${styles.badge} ${
                    member.emailVerified ? styles.badgeVerified : styles.badgeUnverified
                  }`}
                >
                  {member.emailVerified ? "Verified" : "Unverified"}
                </span>
              </td>
              <td className={`${styles.td} ${styles.date}`}>
                {new Date(member.addedAt).toLocaleDateString()}
              </td>
              {canManageMembers && (
                <td className={styles.td}>
                  <button
                    onClick={() => onRemoveMember?.(member.userId, member.email)}
                    disabled={removingMemberId === member.userId}
                    className={styles.removeButton}
                  >
                    {removingMemberId === member.userId ? "Removing..." : "Remove"}
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
